module.exports = __webpack_public_path__ + "static/media/birds-eye-village-annotated-laptop-01.c499a5b8.svg";